import { createFileRoute } from "@tanstack/react-router";
import { CRM } from "@/components/CRM";

function RouteComponent() {
  return <CRM />;
}

export const Route = createFileRoute("/_authenticated/sales/")({
  component: RouteComponent,
  staticData: { page: "sales" },
});
